import { FilterTagButton } from "../../../components/buttons/FilterTag";
import { ComicFacetGroupEntity } from "../../../services/gc/types";
import { Option } from "../../../types";
import { FacetGroupFilter } from "../components/filters/FacetGroupFilter";
import { FilterTitle } from "../../../components/filters/FilterTitle";
import { cloneElement, useMemo } from "react";

export function useComicFacetGroupFilter(
  comicFacets: Record<string, string[]>,
  isModal: boolean,
  comicFacetGroups: ComicFacetGroupEntity[],
  onChange: (categoryId: number, value: string[]) => void,
  icon: React.ReactElement,
) {
  return useMemo(() => {
    return comicFacetGroups.map((comicFacetGroup, i) => {
      const filterState = comicFacets[`${comicFacetGroup.id}`];
      const activeFacetCount = filterState?.length;
      const options: Option<string>[] =
        comicFacetGroup.comic_facet_group_options.map((option) => ({
          label: option.name,
          value: "" + option.id,
        }));

      const iconWithProps = icon ? cloneElement(icon, { boxSize: "24px", color: "neutral.400" }) : undefined;
      const title = isModal ? (
        <FilterTitle
          text={comicFacetGroup.display_name}
          activeFilters={activeFacetCount}
          icon={iconWithProps}
        />
      ) : (
        <FilterTagButton
          icon={icon}
          text={comicFacetGroup.display_name}
          isFiltering={activeFacetCount > 0}
          activeFilters={activeFacetCount}
        />
      );

      const filter = (
        <FacetGroupFilter
          key={i}
          options={options}
          value={filterState ? filterState.map((val) => val) : []}
          onChange={(nextValue) => {
            onChange(comicFacetGroup.id, nextValue);
          }}
          tinted={isModal}
        />
      );

      return [
        title,
        filter,
        {
          value: filterState ?? [],
          onChange: (nextValue: string[]) =>
            onChange(comicFacetGroup.id, nextValue),
        },
      ];
    });
  }, [comicFacetGroups, comicFacets]);
}
